// extracted by mini-css-extract-plugin
export default {"errorIconContainer":"src-components-Modules-revamp-ContentPages-css-module__errorIconContainer--6EwpF"};